import { Button, Radio, CloseIcon, Drawer, Text } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import styles from './drawer-filter.module.css'

import { DashboardDrawerFilterProps } from './drawer-filter.type'
import { IAConversationRoleEnum } from '@/types'

export const DashboardDrawerFilter = ({
  isOpen,
  onHandleOpen,
  filter,
  onHandleFilter,
}: DashboardDrawerFilterProps) => {
  const { t } = useTranslation('screenAiCenter')
  const { t: tEnums } = useTranslation('enums')

  const onChangeValue = (key: string, value: string) => {
    onHandleFilter({ ...filter, [key]: value })
  }
  return (
    <Drawer isOpen={isOpen} onHandleOpen={onHandleOpen}>
      <div className={styles.header}>
        <Text variant="title-large" className={styles['header-title']}>
          {t('conversationTableFilterTitle')}
        </Text>

        <button
          className={styles['header-button']}
          type="button"
          onClick={onHandleOpen}
        >
          <CloseIcon />
        </button>
      </div>

      <div className={styles.content}>
        <div className={styles['content-filter']}>
          <Text variant="title-base">{t('conversationTableFilterRole')}</Text>

          <div className={styles['content-filter-group-options']}>
            <Radio
              value={filter.role === ''}
              onChange={() => onChangeValue('role', '')}
            >
              {t('conversationTableFilterRoleAll')}
            </Radio>

            {Object.values(IAConversationRoleEnum).map((role) => (
              <Radio
                key={role}
                value={filter.role === role}
                onChange={() => onChangeValue('role', role)}
              >
                {tEnums(`conversation_role_${role}`)}
              </Radio>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" onClick={onHandleOpen}>
          {t('conversationTableFilterButtonBack')}
        </Button>
      </div>
    </Drawer>
  )
}
